import { useSession } from "@/lib/auth/auth";
import { setTag, setUser } from "@sentry/react";
import { useEffect } from "react";

export const SentryUserManagement = () => {
  const session = useSession();

  useEffect(() => {
    const user = session?.data?.user;

    if (user) {
      setUser({
        id: user.id ?? "unknownUserId",
        email: user.email ?? "unknownUser",
      });
      setTag("email", user.email ?? "unknownUser");
    } else {
      setUser(null);
    }
  }, [session]);

  return null;
};
